import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-dialog-title" }
const _hoisted_2 = { class: "step" }
const _hoisted_3 = { class: "active" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomConfirmDialog = _resolveComponent("CustomConfirmDialog")

  return (_openBlock(), _createBlock(_component_CustomConfirmDialog, {
    group: "confirm",
    isConfirm: true,
    class: "request-confirm"
  }, {
    title: _withCtx(() => [
      _createVNode("span", _hoisted_1, _toDisplayString(_ctx.t('saved requesting reservation')), 1)
    ]),
    message: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", null, _toDisplayString(_ctx.t('request reservation')), 1)
        ]),
        _createVNode("div", null, [
          _createVNode("div", null, _toDisplayString(_ctx.t('confirm reservation')), 1)
        ])
      ])
    ]),
    _: 1
  }))
}